export default "__VITE_ASSET__9f4edeeb__"